import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

export default function Key({ value }: { value: string }) {
	return <BlockContainer>{value}</BlockContainer>;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const BlockContainer = styled.div({
	display: 'block',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});
